import React, { Fragment, useState } from 'react'
import cx from 'classnames';

import { TableHead, TableRow, TableCell, TableSortLabel, Checkbox } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const TableHeader = (props) => {
    const { disableItemSelection = false, columnsView, onChangeColumns, hideDragable, selectedItems, onChageSelectedItems, dataItems, sort, lockedColumns, menuOptions, lockedColumnsHandler, customColumn } = props;
    return (
        <TableHead>
            {
                hideDragable ?
                    <TableRow>
                        {
                            !disableItemSelection &&
                            <TableCell padding="checkbox" className={cx(lockedColumns && "locked-header")}>
                                <Checkbox
                                    style={{ color: "black" }}
                                    indeterminate={selectedItems.length > 0 && selectedItems.length < dataItems.length}
                                    checked={selectedItems.length == dataItems.length}
                                    onClick={(event) => {
                                        if (event.target.checked) {
                                            onChageSelectedItems(dataItems);
                                        }
                                        else {
                                            onChageSelectedItems([])
                                        }
                                    }}
                                    inputProps={{ 'aria-label': 'select all desserts' }}
                                    size="small"
                                />
                            </TableCell>
                        }
                        {
                            menuOptions &&
                            <TableCell
                                padding="checkbox"
                                className={cx("context-menu-container", lockedColumns && "locked-header")}
                            >
                                <div style={{ width: 43 }}></div>
                            </TableCell>
                        }
                        {
                            customColumn &&
                            <TableCell
                                padding="checkbox"
                                className={cx("context-menu-container", lockedColumns && "locked-header")}
                            >
                                <div style={{ width: 43 }}>
                                    {
                                        customColumn?.sort ?
                                            <TableSortLabel
                                                active={sort?.key === customColumn.sort}
                                                direction={sort?.key === customColumn.sort ? sort?.order : 'asc'}
                                                onClick={() => {
                                                    let newSort = sort
                                                    if (sort?.key === customColumn.sort)
                                                        newSort = { key: customColumn.sort, order: sort?.order == 'asc' ? 'desc' : 'asc' }
                                                    else
                                                        newSort = { key: customColumn.sort, order: 'asc' }

                                                    onChangeSort(newSort)
                                                }}
                                            >

                                            </TableSortLabel>
                                            : <></>
                                    }
                                </div>
                            </TableCell>
                        }
                        {
                            columnsView.map((item, index) => {
                                return (
                                    <TableCell
                                        key={index}
                                        style={{
                                            width: item.width,
                                            minWidth: item.width,
                                            height: 44,
                                            left: item.locked && lockedColumnsHandler(index, columnsView, disableItemSelection, "header")
                                        }}
                                        id={`header-${item.key}`}
                                    >
                                        {
                                            item.sort ?
                                                <TableSortLabel
                                                    active={sort?.key === item.key}
                                                    direction={sort?.key === item.key ? sort?.order : 'asc'}
                                                    onClick={() => {
                                                        let newSort = sort
                                                        if (sort?.key === item.key)
                                                            newSort = { key: item.key, order: sort?.order == 'asc' ? 'desc' : 'asc' }
                                                        else
                                                            newSort = { key: item.key, order: 'asc' }

                                                        onChangeSort(newSort)
                                                    }}
                                                >
                                                    {item.title}
                                                </TableSortLabel>
                                                : item.title

                                        }
                                    </TableCell>
                                )
                            })
                        }
                    </TableRow>
                    :
                    <DragDropList
                        items={columnsView}
                        keyName="key"
                        className="header_drag-drop-list-container"
                        direction="horizontal"
                        itemRenderer={(col) => {
                            return (
                                <div key={col.key}>
                                    {col.title}
                                </div>
                            );
                        }}
                        onDragEnd={(result) => {
                            if (!result.destination) return;

                            const newColumns = [...columnsView];

                            const [reorderedItem] = newColumns.splice(result.source.index, 1);
                            newColumns.splice(result.destination.index, 0, reorderedItem);

                            onChangeColumns(newColumns);
                        }}
                        {...props}
                    />
            }

        </TableHead>
    )
}

export default TableHeader;

const DragDropList = (props) => {
    const { disableItemSelection = false, items, keyName, itemRenderer, onDragEnd, direction, isDragDisabled, sort, onChangeSort, selectedItems, onChageSelectedItems, lockedColumns, lockedColumnsHandler, onChangeColumns, menuOptions, customColumn } = props;
    return (
        <Fragment>
            <DragDropContext onDragEnd={onDragEnd} alwaysRenderSuggestions={true}>
                <Droppable
                    droppableId="droppable"
                    direction={direction || 'vertical'}
                    renderClone={(provided, snapshot, rubric) => (
                        <div
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}
                            className="droppable-cell"
                        >
                            {
                                itemRenderer && itemRenderer(items[rubric.source.index]) || items[rubric.source.index][keyName]
                            }
                        </div>
                    )}
                >
                    {(provided, snapshot) => (
                        <TableRow
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className={cx("drag-drop-list-container", snapshot.isDraggingOver ? 'dragged' : 'dragging')}
                        >
                            {
                                !disableItemSelection &&
                                <TableCell padding="checkbox" className={cx(lockedColumns && "locked-header")}>
                                    <Checkbox
                                        style={{ color: "black" }}
                                        indeterminate={selectedItems.length > 0 && selectedItems.length < props.data.length}
                                        checked={selectedItems.length == props.data.length}
                                        onClick={(event) => {
                                            if (event.target.checked)
                                                onChageSelectedItems(props.data)
                                            else
                                                onChageSelectedItems([])
                                        }}
                                        inputProps={{ 'aria-label': 'select all desserts' }}
                                        size="small"
                                    />
                                </TableCell>
                            }
                            {
                                menuOptions &&
                                <TableCell
                                    padding="checkbox"
                                    className={cx("context-menu-container", lockedColumns && "locked-header")}
                                >
                                    <div style={{ width: 43 }}></div>
                                </TableCell>
                            }
                            {
                                customColumn &&
                                <TableCell
                                    padding="checkbox"
                                    className={cx("context-menu-container", lockedColumns && "locked-header")}
                                >
                                    <div style={{ width: 43, display: 'flex', justifyContent: 'center' }}>
                                        {
                                            customColumn?.sort ?
                                                <TableSortLabel
                                                    active={sort?.key === customColumn.sort}
                                                    direction={sort?.key === customColumn.sort ? sort?.order : 'asc'}
                                                    onClick={() => {
                                                        let newSort = sort
                                                        if (sort?.key === customColumn.sort)
                                                            newSort = { key: customColumn.sort, order: sort?.order == 'asc' ? 'desc' : 'asc' }
                                                        else
                                                            newSort = { key: customColumn.sort, order: 'asc' }

                                                        onChangeSort(newSort)
                                                    }}
                                                >
                                                </TableSortLabel>
                                                : <></>
                                        }
                                    </div>
                                </TableCell>
                            }
                            {
                                items && items.map((item, index) => (
                                    <Draggable
                                        key={`${item[keyName]}`}
                                        draggableId={`${item[keyName]}`}
                                        index={index}
                                        isDragDisabled={isDragDisabled}
                                    >

                                        {(provided, snapshot) => (
                                            <TableCell
                                                className={cx(lockedColumns && item.locked && "locked-header")}
                                                style={{
                                                    width: item.width,
                                                    minWidth: item.width,
                                                    height: 44,
                                                    left: item.locked && lockedColumnsHandler(index, items, disableItemSelection, "header"),
                                                }}
                                                id={`header-${item.key}`}
                                            >
                                                <ResizeCell provided={provided} columns={items} item={item} onChangeColumns={onChangeColumns} key={item?.key}>
                                                    {
                                                        item.sort ?
                                                            <TableSortLabel
                                                                active={sort?.key === item.key}
                                                                direction={sort?.key === item.key ? sort?.order : 'asc'}
                                                                onClick={() => {
                                                                    let newSort = sort
                                                                    if (sort?.key === item.key)
                                                                        newSort = { key: item.key, order: sort?.order == 'asc' ? 'desc' : 'asc' }
                                                                    else
                                                                        newSort = { key: item.key, order: 'asc' }

                                                                    onChangeSort(newSort)
                                                                }}
                                                            >
                                                                {itemRenderer && itemRenderer(item) || item[keyName]}
                                                            </TableSortLabel>
                                                            : itemRenderer && itemRenderer(item) || item[keyName]
                                                    }
                                                </ResizeCell>
                                            </TableCell>
                                        )}
                                    </Draggable>
                                ))
                            }
                            {provided.placeholder}
                        </TableRow>
                    )}
                </Droppable>
            </DragDropContext>
        </Fragment >
    );
}

const ResizeCell = (props) => {
    const { provided, item, columns, onChangeColumns } = props
    const [thElm, setThElm] = useState(null)
    const [startOffset, setStartOffset] = useState(null);

    const mouseUp = (e) => {
        if (thElm) {
            setThElm(undefined)
            setStartOffset(undefined)
            document.removeEventListener("mousemove", mouseMove)
        };
    }

    const mouseMove = (e) => {
        let currentThElm = thElm;
        if (thElm) {
            currentThElm.style.minWidth = startOffset + e.pageX + 'px';
        }
        document.addEventListener('mouseup', mouseUp);
    }

    document.addEventListener('mousemove', mouseMove);

    return (
        <Fragment>
            <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                className="cell-container"
            >
                {props.children}
            </div>
            {item?.resize &&
                <div
                    id={`resize-${item.key}`}
                    className="resizer"
                    onMouseDown={(e) => {
                        let th = document.getElementById(`header-${item.key}`)
                        setThElm(th)
                        setStartOffset(th?.offsetWidth - e.pageX)
                    }}
                    onMouseUp={() => {
                        if (thElm) {
                            let size = parseInt(thElm?.style?.minWidth, 10)
                            let index = columns.findIndex(x => x == item)
                            let newColumns = [...columns]
                            newColumns[index].width = size
                            onChangeColumns && onChangeColumns(newColumns)
                        }
                        setThElm(undefined)
                        setStartOffset(undefined)
                        document.removeEventListener("mousemove", mouseMove)
                        document.removeEventListener("mouseup", mouseUp)
                    }}
                >
                </div>
            }
        </Fragment>
    )
}